/**
 * uniqueId generator, given a value it returns the most space-free string like representation of that value
 */
const uniqueId = (o) => {
  // console.log('uniqueId', o);
  if (o === '') {
    // if a blank string, return without any further processing, hopefully this improves some performance.
    return '';
  }
  if (o === undefined || o === null) {
    // if null or undefined, don't process anymore, just return null
    return null;
  }
  if (Array.isArray(o)) {
    // if array recurse
    return uniqueId(o[0]);
  }
  if (typeof o === 'object') {
    if (o.props.children !== undefined) {
      // if object with children recurse
      return uniqueId(o.props.children);
    }
    // console.error('unrecognised object', o);
    // If the object isn't a react component with children, don't guess, return null
    return null;
  }
  // console.log('uniqueId return string');
  // remove white space from the string
  return o.replace(/\s+/g, '');
};
export default uniqueId;
